import {
  GET_FAMILIES,
} from 'constants/families';

export default (state = [], action) => {
    switch (action.type) {
    case `${GET_FAMILIES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
